import type { OfferCampaignCoupon } from '../types/offer-campaigns';
import { useState } from 'react';
import { fetchOfferCampaignCouponPdf } from '../lib/api/offer-campaigns';
import { OfferCouponCard } from './OfferCouponCard';
import { OfferVisualIcon } from './OfferVisualIcon';

export function OfferCompletionStep({ coupon, displayRouteSlug, onNext, token, notify }: { coupon: OfferCampaignCoupon; displayRouteSlug?: string | null; onNext: () => void; token?: string; notify?: (message: string, type?: 'success' | 'error' | 'warning' | 'info') => void }) {
  const [generating, setGenerating] = useState(false);
  const viewPdf = async () => {
    setGenerating(true);
    try {
      const blob = await fetchOfferCampaignCouponPdf(coupon.campaignKey, coupon.enrollmentId, token);
      const url = URL.createObjectURL(blob);
      window.open(url, '_blank', 'noopener,noreferrer');
      window.setTimeout(() => URL.revokeObjectURL(url), 60_000);
    } catch {
      notify?.('The coupon PDF could not be generated. No document was opened. Please try again.', 'error');
    } finally { setGenerating(false); }
  };
  return (
    <div className="offer-campaign-coupon offer-coupon-card offer-campaign-complete-burst">
      <div className="offer-campaign-sparkles" aria-hidden="true">
        <i />
        <i />
        <i />
        <i />
      </div>
      <OfferVisualIcon name="sparkles" />
      <OfferCouponCard coupon={coupon} />
      <div className="offer-campaign-actions">
        <button className="btn btn-primary" type="button" onClick={onNext}>Start New Enrollment</button>
        <button className="btn btn-outline" type="button" onClick={() => void viewPdf()} disabled={generating}>{generating ? 'Generating coupon...' : 'View / Print Coupon PDF'}</button>
        {displayRouteSlug && <button className="btn btn-outline" type="button" onClick={() => window.open(`/displaylinks/${encodeURIComponent(displayRouteSlug)}`, '_blank', 'noopener,noreferrer')}>Open Display Page</button>}
      </div>
    </div>
  );
}
